import React from 'react'
import SvgIcon from 'src/components/SvgIcon'

import styles from './AvatarImage.module.less'

const AvatarImage = ({ avatar, size = '75px', fallback = 'img' }) => {
  if (!avatar && fallback === 'icon') {
    return (
      <div
        className={styles.fallbackIconHolder}
        style={{ width: size, height: size, lineHeight: size }}
      >
        <SvgIcon type='Person' className={styles.fallbackIcon} />
      </div>
    )
  }

  // Take "empty" avatar image if not received
  const getAvatar =
    avatar || require('src/modules/Chat/Conversations/MessageItem/assets/admin-profile.png')

  return (
    <div
      className={styles.avatar}
      style={{
        backgroundImage: `url(${getAvatar})`,
        width: size,
        height: size,
      }}
    />
  )
}

export default AvatarImage
